<template>
  <page>
    <template slot="title">Раскрытие информации</template>
    <template slot="section">
      <columns>
        <column size="10">
          <heading>Раскрытие информации субъектом рынка электроэнергии</heading>
        </column>
        <column size="10">
          <p>Информация, подлежащая обязательному опубликованию субъектом рынка электроэнергии в соответствии со Стандартами раскрытия информации субъектами оптового и розничных рынков электрической энергии, утвержденных <a href="https://www.mos.ru/upload/documents/oiv/postanovlenie_ot_21_yanvarya_2004_g_24.pdf" target="_blank">Постановлением Правительства РФ от 21.01.2004 № 24</a></p>
          <!--<p><b>Учредительные документы и внутренние документы:</b></p>
          <div class="documents">
            <doc v-for="(doc, index) in allDocuments" :key="index" :url="doc.url" :title="doc.title"/>
          </div>-->
        </column>
      </columns>
    </template>
    <template slot="aside">
      <aside-image :image="imageBg"/>
    </template>
  </page>
</template>

<script>
import imageBg from '../../static/i/img-07.jpg';

import Columns from '@/components/columns/Columns';
import Column from '@/components/columns/Column';
import Heading from '@/components/Heading';
import Page from '@/components/Page';
import AsideImage from '@/components/AsideImage';

export default {
  components: {
    Columns,
    Column,
    Heading,
    Page,
    AsideImage,
  },
  data: () => {
    return {
      imageBg: imageBg,
      allDocuments: null,
    }
  },
  mounted() {
    this.allDocuments = require('@/data/documents.json');
  }
}
</script>

<style lang="scss">
.documents {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 20px 0 0;
}
</style>



// WEBPACK FOOTER //
// Legal.vue?1876527e